import { AzureDataExplorerSinkAdapter } from 'app/model/adapters/activities/copysink/azure-data-explorer.sink.adapter';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';
import { KustoDatabaseCopySink } from 'app/model/pipeline/copysink/kusto-database.copysink';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoDatabaseCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        ingestionMappingName: '*',
        structure: '*',
        additionalProperties: '*'
    }
})
export class KustoDatabaseSinkAdapter extends AzureDataExplorerSinkAdapter {
    protected override model(): IModel {
        return KustoDatabaseCopySink.MODEL;
    }
}
